import { FormField } from '@/components/ui/FormField';
import { cn } from '@/utils/cn';

interface ClinicalTextAreaProps {
  label: string;
  value: string;
  maxLength: number;
  onChange?: (next: string) => void;
  rows?: number;
}

/** Free clinical text, the same limit the API holds. Read-only when there is nothing to change it with. */
export function ClinicalTextArea({
  label,
  value,
  maxLength,
  onChange,
  rows = 3,
}: ClinicalTextAreaProps) {
  return (
    <FormField label={label}>
      {({ id, describedBy }) =>
        onChange ? (
          <textarea
            id={id}
            aria-describedby={describedBy}
            value={value}
            maxLength={maxLength}
            rows={rows}
            onChange={(event) => onChange(event.target.value)}
            className={cn(
              'border-line w-full rounded-lg border bg-white px-3 py-2.5 text-sm',
              'focus:border-brand-500 focus:ring-brand-100 focus:ring-4 focus:outline-none',
            )}
          />
        ) : (
          <p id={id} className="text-ink min-h-6 text-sm whitespace-pre-wrap">
            {value.trim() === '' ? '—' : value}
          </p>
        )
      }
    </FormField>
  );
}
